export const newestToOldest = (left, right) => {
  if (left.date > right.date) {
    return 1
  }
  if (left.date < right.date) {
    return -1
  }
  return 0
}
